import React, { useState } from "react";
import { View } from "react-native";

import { Button, Icon, Text, TextArea } from "component";

import { colors, strings } from "asset/constant";

import { mq } from "utils";
import { css } from "style";

export default function CompletionAlertCard(props: {
  onConfirm: (desc: string) => void;
  close: () => void;
}) {
  const [description, setDescription] = useState("");

  const _onConfirm = () => {
    props.onConfirm(description);
  };

  return (
    <>
      <View style={{ ...css.centralElements, paddingHorizontal: mq(5) }}>
        <Icon color={colors.theme} size={mq(25)} name="checkcircle" />
        <Text align="center" weight="extraBold" size={"xl"}>
          {strings.complete_the_purchase}
        </Text>

        <View style={{ marginTop: mq(20) }}>
          <Text
            size={"sm"}
            weight="bold"
            style={{ marginBottom: mq(10), lineHeight: mq(20) }}
          >
            درصورتیکه توضیحی برای این سفارش دارید در کادر زیر وارد کنید
          </Text>
          <TextArea
            value={description}
            onChangeText={setDescription}
            icon={{ type: "materialCommunity", name: "format-align-right" }}
            placeholder={strings.insert_description}
          />
        </View>

        <View
          style={{
            ...css.rRowCenterAlign,
            ...css.fitWidth,
            ...css.justifySBetween,
          }}
        >
          <Button
            onPress={props.close}
            bordered={{ width: 1, color: colors.theme }}
            bgColor={colors.transparent}
            width={"46%"}
            title={{ value: strings.cancel, color: colors.theme }}
          />
          <Button
            width={"46%"}
            title={{ value: strings.submit_order }}
            onPress={_onConfirm}
          />
        </View>
      </View>
    </>
  );
}
